import script from "./SidenavItemDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavItemDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SidenavItemDropdown.vue?vue&type=style&index=0&id=d02ffdf2&lang=css"

const __exports__ = script;

export default __exports__